// fix url
export function fixUrl (url) {
  if (/^http.*$/.test(url)) {
    return url
  }
  return `http://${url}`
}

export default {
  fixUrl
}
